export default {
  findRouteByQuote: {
    method: 'post',
    url: '/order/route/find-by-quote'
  },
  findRouteByQuoteRequestData: {
    method: 'post',
    url: '/order/route/find-by-data-quote-request'
  }
}
